import { useQuery } from "../_app/lib/query";
import { useStore } from "../_app/hooks";
import { getSupportContact } from "./api";
import { DEFAULT_BRAND } from "./utils";
import { useContextProvider } from "../context/providers/ContextProvider";

export function useBrand() {
  const { state } = useStore();
  return state.brand || DEFAULT_BRAND;
}

export function useBrandColors() {
  let brand = useBrand();
  return {
    primary: brand?.primaryColour,
    secondary: brand?.secondaryColour,
    tertiary: brand?.tertiaryColour,
    primary_text: brand?.primaryTextColour,
    secondary_text: brand?.secondaryTextColour,
    tertiary_text: brand?.tertiaryTextColour,
  };
}

export function useBrandName() {
  const brand = useBrand();
  return brand.name;
}

export function useLogo() {
  const brand = useBrand();
  return brand.logoUrl;
}

export function useBrandWelcomeText() {
  const brand = useBrand();
  return brand.welcomeText || "Welcome to " + brand.name;
}

export function useLoginBackground() {
  const brand = useBrand();
  return brand.backgroundImageUrl;
}

export function useHeadingText() {
  const brand = useBrand();
  return brand.headingText || DEFAULT_BRAND.headingText;
}

export function useSubHeadingText() {
  const brand = useBrand();
  return brand.subHeadingText || (!brand.headingText ? DEFAULT_BRAND.subHeadingText : "");
}

export function usePromotion() {
  const brand = useBrand();
  return brand.promotion;
}

export function useFooterLinks() {
  const brand = useBrand();
  return brand.footerLinks || [];
}

export function useFooterWidget1() {
  const brand = useBrand();
  return brand.widgetArea1;
}

export function useFooterWidget2() {
  const brand = useBrand();
  return brand.widgetArea2;
}

export function usePoweredByLogo() {
  //@todo - local asset required
  return undefined;
}

export function useCustomerServices(options = {}) {
  const { contextId: accountId } = useContextProvider();
  return useQuery({
    queryKey: ["contact", accountId],
    queryFn: () => getSupportContact(accountId),
    ...options,
  });
}
